import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FlowManagerService } from '../../services/flow-manager.service';
import { FlowManagerUtil } from '../../../../shared/utils/flow-manager-util';
import { SharedService } from '../../../../core/services/store/shared-store/shared-storage.service';
import {AbstractControl, FormControl, Validators} from "@angular/forms";
import {ManagementService} from "../../../../core/services/management/management.service";
import {ToastBannerService} from "../../../../shared/components/cms/toast-banner/toast-banner.service";
import {RolesService} from "../../../../core/services/roles/roles.service";
import {Observable, of} from "rxjs";
import {MatFormField} from "@angular/material/form-field";
import {flowNameValidator} from "../../../../shared/utils";

@Component({
  selector: 'app-copy-flow',
  templateUrl: './copy-flow.component.html',
  styleUrls: ['./copy-flow.component.scss'],
})
export class CopyFlowComponent implements OnInit {
  flowId: any;
  newFlowName = new FormControl('', flowNameValidator());
  requestFlowLoad: string;
  requestRouteLoad: string;
  selectedEntityId: string;
  savingInProgress: Boolean = false;
  isInternalAdmin: Boolean = false;

  clients: any;
  selectedEntityName: string;
  clientNameObs: Observable<any>;
  clientNameSearchInput = new FormControl();
  numberOfOptions: number;
  oldFlowName: string;

  @ViewChild('selectArrow') selectArrow: ElementRef;
  @ViewChild('entitySearchForm') entitySearchForm: MatFormField;
  @ViewChild('autoComplete') autocomplete;
  @ViewChild('entitySelectionInput') entitySelectionInput: ElementRef;

  selectedClientNameIndex: number;

  constructor(
    public dialogRef: MatDialogRef<CopyFlowComponent>,
    private flowManagerService: FlowManagerService,
    public sharedService: SharedService,
    public managementService: ManagementService,
    private rolesService: RolesService,
    private toastService: ToastBannerService
  ) {}

  ngOnInit() {
    this.flowId = this.dialogRef._containerInstance._config.data.flowId;
    const path = this.dialogRef._containerInstance._config.data.path;
    const flowName = this.dialogRef._containerInstance._config.data.flowName;
    this.newFlowName.patchValue(path + flowName + '_COPY');
    this.selectedEntityId = this.sharedService.getEntityId();
    this.isInternalAdmin = this.rolesService.isInternalAdmin();

    this.oldFlowName = this.dialogRef._containerInstance._config.data.flowName;

    this.clientNameSearchInput.valueChanges.subscribe(
        val => this.clientNameFilter(val)
    );

    this.setCurrentClient();
    this.clientNameObs = this.managementService.getEntities();
  }

  setCurrentClient() {
    this.managementService.getEntities().subscribe(
        (clientData) => {
          this.clients = clientData;
          this.selectedEntityName = this.getClient(this.selectedEntityId)[0]['value'];
          this.clientNameSearchInput.setValue(this.selectedEntityName);
        }
    );
  }

  maintainOriginalObservableOrder(): number {
    return 0;
  }

  clientNameFilter(value: string) {
    const filterText = value.toLowerCase();
    const filteredMap = this.clients.filter(obj => obj.value.toLowerCase().includes(filterText));
    this.numberOfOptions = filteredMap.length;
    this.clientNameObs = of(filteredMap);
    if (this.numberOfOptions < 1) {
      this.entitySearchForm._elementRef.nativeElement.style.border = '1px solid #c23313';
    }
  }

  clearEntityNameInput() {
    this.updateClientNameListPosition();
    this.clientNameObs = of(this.clients);
  }

  updateClientNameListPosition() {
    if (this.autocomplete !== undefined && this.autocomplete.panel !== undefined) {
      const matOptionHeight = 48;
      const matOptionPosition = matOptionHeight * this.selectedClientNameIndex;
      setTimeout(() => {
        this.autocomplete.panel.nativeElement.scrollTop = matOptionPosition;
        this.highlightSelectedClientOption();
      }, 0);
    }
  }

  highlightSelectedClientOption() {
    const elem = this.autocomplete.options._results[this.selectedClientNameIndex] as ElementRef;
    elem['_element'].nativeElement.classList.add('selected-client-option');
  }

  populateEntityNameInput() {
    if (this.clientNameSearchInput.value === '') {
      this.clientNameSearchInput.setValue(this.selectedEntityName);
    }
  }

  getClient(clientId) {
    return this.clients.filter((obj, index) => {
      if (obj['key'] === clientId.toString()) {
        this.selectedClientNameIndex = index;
        return obj['key'] === clientId.toString();
      }
    });
  }

  onClientNameInputToggle() {
    if (
        this.selectArrow.nativeElement.style.transform === '' ||
        this.selectArrow.nativeElement.style.transform === 'rotate(0deg) translateY(2px)'
    ) {
      this.clientNameSearchInput.setValue('');
      this.setOpenSearchPanelIcon();
    } else {
      this.populateEntityNameInput();
      this.setClosedSearchPanelIcon();
    }
  }

  setOpenSearchPanelIcon() {
    this.selectArrow.nativeElement.style.transform = 'rotate(180deg) translateY(0px)';
    this.entitySearchForm._elementRef.nativeElement.style.border = '1px solid #2cc4ec';
  }

  setClosedSearchPanelIcon() {
    this.selectArrow.nativeElement.style.transform = 'rotate(0) translateY(2px)';
    if (this.numberOfOptions < 1) {
      this.entitySearchForm._elementRef.nativeElement.style.border = '1px solid #c23313';
    } else {
      this.entitySearchForm._elementRef.nativeElement.style.border = '1px solid #d4d9e2';
    }
  }

  onClientSelected() {
    this.entitySelectionInput.nativeElement.blur();
    this.selectedEntityName = this.clientNameSearchInput.value;
    this.clients.filter((obj, index) => {
      if (obj['value'] === this.selectedEntityName) {
        this.selectedClientNameIndex = index;
        this.selectedEntityId = obj['key'];
      }
    });
  }

  saveFlow() {
    const path = this.newFlowName.value;
    const flowNameToUse = FlowManagerUtil.sanitizeFlowName(this.newFlowName.value);

    const stageRequest = {
      flowId: this.flowId,
      flowName: flowNameToUse,
      flowPath: path,
      clientId: this.selectedEntityId
    };

    if (this.selectedEntityId === this.sharedService.getEntityId()) {
        const sameName = this.sharedService.checkSameFlowName('move', { flowPath: path });
        if (sameName) {
            this.displayBanner(
                '#F8BD32',
                'redesign/ExclamationMark.svg',
                `Flow with same name already exist!`,
                ``,
                false,
                true
            );
            return;
        }
    }



    this.savingInProgress = true;
    this.flowManagerService.saveCopyOfFlow(stageRequest).subscribe((response) => {
      this.savingInProgress = false;
      this.dialogRef.close();

      if (response === true) {
        this.displayBanner(
            '#8cc63f',
            'redesign/Check_Mark_Filled.svg',
            `Flow successfully duplicated.`,
            ``,
            false,
            true
        );
        this.flowManagerService.getFlows(true);
        return;
      }
      this.displayBanner(
          '#C23313',
          'redesign/ExclamationMark_Red.svg',
          `Failed to duplicate flow!`,
          ``,
          false,
          true
      );
    }, error => {
      this.savingInProgress = false;

      this.displayBanner(
          '#F8BD32',
          'redesign/ExclamationMark.svg',
          `${error.error}`,
          ``,
          false,
          true
      );
    });
  }

  canSaveFlow() {
    return this.newFlowName.valid;
  }

  closeModal() {
    this.dialogRef.close();
  }

  getErrorMessage() {
    return 'Please enter flow name.';
  }

  displayBanner(lineColor: string, icon: string, title: string, descrip: string, bigIcon: boolean, closeIcon: boolean): void {
    this.toastService.setBannerParams({ lineColor, icon, title, descrip, bigIcon, closeIcon });
    setTimeout(() => {
      this.toastService.clearBannerParams();
    }, 5000);
  }
}
